module.exports = __webpack_public_path__ + "media/images/upvote-67398e8786cb39bb1834eec1874acc34.svg";